export default [
  {
    path: '/cs-home',
    name: 'CSHome',
    component: () => import('@/views/csHome/home'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
]